import React from 'react'
import PropTypes from 'prop-types'
import EventsMain from './EventsMain'

import ModuleProvider from './providers/ModuleProvider'

/**
  index.js --> EventsMain.js -----> Filters
                              \
                               \--> List
 */

/**
 * @returns {JSX.Element}
 * @constructor
 */

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function Events(props) {
  return (
    <ModuleProvider CMSProps={props}>
      <EventsMain />
    </ModuleProvider>
  )
}

Events.propTypes = {
  CMSProps: PropTypes.object,
  attachments: PropTypes.array
}

export default Events
